"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BACKGROUND_STYLE = {
    // fill: 'red',
    opacity: 0,
};
exports.LINE_STYLE = {
    stroke: '#C5C5C5',
    strokeOpacity: 0.85,
};
exports.AREA_STYLE = {
    fill: '#CACED4',
    opacity: 0.85,
};
//# sourceMappingURL=constant.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/gui/lib/trend/constant.js
// module id = 1053
// module chunks = 37